import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { reviews } from "@/mocks/media";

const stanceStyle: Record<string, string> = {
  推荐: "bg-secondary-100 text-secondary-900",
  中立: "bg-accent-100 text-accent-800",
  保留: "bg-primary-100 text-primary-700",
};

export default function Reviews() {
  return (
    <section id="reviews" className="w-full bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <Reveal>
            <SectionHeading
              eyebrow="Reviews"
              title="影评观点：好在哪里，争议又在哪里"
              desc="同一个作品，不同观众会看到不同的东西。下面整理了四种不同立场的评价，既有认可，也有保留意见，方便你对照着形成自己的判断。"
            />
          </Reveal>

          <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {reviews.map((review, index) => (
              <Reveal key={review.id} delay={index * 70}>
                <article className="h-full flex flex-col p-6 md:p-7 rounded-lg bg-background-50 border border-background-200">
                  <div className="flex items-start justify-between gap-4">
                    <div>
                      <span
                        className={`inline-block px-2.5 py-1 rounded-full font-label text-xs ${
                          stanceStyle[review.stance] ?? "bg-background-100 text-foreground-600"
                        }`}
                      >
                        {review.stance}
                      </span>
                      <h3 className="mt-3 font-heading text-lg md:text-xl font-bold text-foreground-950">
                        {review.title}
                      </h3>
                      <p className="mt-1 font-label text-xs md:text-sm text-foreground-500">
                        {review.author}
                      </p>
                    </div>
                    <div className="flex flex-col items-center shrink-0">
                      <span className="font-heading text-3xl font-bold text-primary-500 leading-none">
                        {review.score}
                      </span>
                      <span className="font-label text-[11px] text-foreground-400 mt-1">
                        评分 / 10
                      </span>
                    </div>
                  </div>

                  <p className="mt-4 font-heading text-sm md:text-base text-foreground-800 italic">
                    「{review.quote}」
                  </p>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600 flex-1">
                    {review.body}
                  </p>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}